import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import useTranslation from '../../../../hooks/useTranslation';

import './ScrollToTopButton.scss';

type Props = {
    show?: boolean;
};

const ScrollToTopButton: React.FC<Props> = ({ show = false }) => {
    const translated = useTranslation();
    const [localShow, setLocalShow] = useState(show);

    useEffect(() => {
        const timeout = setTimeout(() => setLocalShow(show), !show ? 500 : 300);

        return () => clearTimeout(timeout);
    }, [show]);

    return (
        <div className={classNames('scroll-to-top__wrapper', { show: localShow })}>
            <IconButton
                className="scroll-to-top__button"
                icon={IconTypes.PIL_OPP}
                onClick={() => window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })}
                buttonType="icon-negative"
                screenReaderText={translated.goToTop}
            >
                <span className="scroll-to-top__button-label">{translated.goToTop}</span>
            </IconButton>
        </div>
    );
};

export default ScrollToTopButton;
